
import MainLayout from "@/components/layout/MainLayout";
import HeroSection from "@/components/home/HeroSection";
import FeaturesSection from "@/components/home/FeaturesSection";
import WeatherCard from "@/components/weather/WeatherCard";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const navigate = useNavigate();
  
  return (
    <MainLayout>
      <HeroSection />
      
      <FeaturesSection />
      
      <section className="py-16 bg-white">
        <div className="travel-container">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">AI Travel Assistant</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Chat with our intelligent assistant to get personalized travel recommendations, advice, and help planning your perfect trip.
            </p>
          </div>
          
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 order-2 lg:order-1">
              <div className="bg-gray-100 rounded-lg p-6">
                <h3 className="font-medium text-lg mb-2">Ask our AI about:</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-travel-blue rounded-full mr-2"></span>
                    Destination recommendations based on your preferences
                  </li>
                  <li className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-travel-blue rounded-full mr-2"></span>
                    Local attractions, cuisine, and cultural customs
                  </li>
                  <li className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-travel-blue rounded-full mr-2"></span>
                    Travel tips, packing advice, and safety information
                  </li>
                  <li className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-travel-blue rounded-full mr-2"></span>
                    Budget planning and cost-saving strategies
                  </li>
                  <li className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-travel-blue rounded-full mr-2"></span>
                    Personalized itinerary suggestions
                  </li>
                </ul>
                
                <Button 
                  className="mt-6 w-full bg-travel-blue hover:bg-blue-700"
                  onClick={() => navigate("/assistant")}
                >
                  Start Chatting
                </Button>
              </div>
            </div>
            
            <div className="flex-1 order-1 lg:order-2">
              <div className="bg-gray-50 p-4 rounded-lg border shadow-sm">
                <div className="bg-white p-4 rounded-lg shadow-sm space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 rounded-full bg-travel-blue flex items-center justify-center text-white font-bold mr-3 mt-1">
                      AI
                    </div>
                    <div className="bg-gray-100 p-3 rounded-lg">
                      <p>Hello! I'm your AI travel assistant. How can I help plan your trip today?</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start justify-end">
                    <div className="bg-travel-blue text-white p-3 rounded-lg">
                      <p>I'm planning a trip to Bali for 5 days. What are the must-see attractions?</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="w-8 h-8 rounded-full bg-travel-blue flex items-center justify-center text-white font-bold mr-3 mt-1">
                      AI
                    </div>
                    <div className="bg-gray-100 p-3 rounded-lg">
                      <p>For a 5-day trip to Bali, here are the must-see attractions:</p>
                      <ol className="list-decimal list-inside space-y-1 mt-1">
                        <li>Ubud Sacred Monkey Forest and Rice Terraces</li>
                        <li>Tanah Lot and Uluwatu Temple for stunning sunset views</li>
                        <li>Beaches: Kuta, Seminyak, or the quieter Nusa Dua</li>
                        <li>Mount Batur sunrise trekking experience</li>
                        <li>Tegalalang Rice Terraces and local art villages</li>
                      </ol>
                      <p className="mt-1">Would you like a suggested day-by-day itinerary for these attractions?</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="py-16 bg-gray-50">
        <div className="travel-container">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Check Your Destination's Weather</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Use our weather tool to get accurate forecasts for your travel destination.
            </p>
          </div>
          
          <div className="max-w-md mx-auto">
            <WeatherCard />
          </div>
        </div>
      </section>
      
      <section className="py-16 bg-travel-blue text-white">
        <div className="travel-container">
          <div className="text-center">
            <h2 className="text-3xl font-bold mb-4">Ready to Plan Your Perfect Trip?</h2>
            <p className="text-xl opacity-90 mb-8">
              Let our AI travel assistant help you create memorable experiences.
            </p>
            <Button 
              size="lg"
              className="bg-white text-travel-blue hover:bg-gray-100"
              onClick={() => navigate("/assistant")}
            >
              Get Started Now
            </Button>
          </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default Index;
